const preload = (image) => {
  const { media, src, srcset } = preloadImageByDevice(image)
  document.head.insertAdjacentHTML(
    'beforeend',
    `<link as="image" rel="preload" fetchpriority="low" media="${media}" href="${src}" imagesrcset="${srcset}">`
  )
}

const preloadImageByDevice = (image) => {
  const isMobile = window.innerWidth < 768
  const { src, srcset } = image

  return {
    src: isMobile ? src : src.replace(/xs/gi, 'sm'),
    media: isMobile ? '(max-width: 767px)' : '(min-width: 767px)',
    srcset: isMobile ? srcset : srcset.toString().replace(/xs/gi, 'sm'),
  }
}

export default { preload, preloadImageByDevice }
